module.exports = __webpack_public_path__ + "static/media/Screenshot 2024-08-18 at 11.55.40.49935dcf.png";